<span [innerHTML]="src | loadSvg | async" [attr.string]="svgId"></span>
